import { createTheme, ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import OppTagStats from './components/OppTagStats'

// Create MUI theme matching client-app
const theme = createTheme({
  typography: {
    fontFamily: 'Work Sans, Arial, sans-serif',
  },
})

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <OppTagStats />
    </ThemeProvider>
  )
}

export default App
